import { useRecordingContext } from "../contexts/RecordingContext";

export default function useMediaRecorderUploader() {
  return useRecordingContext();
}